'use client';

import { Help } from '@shared/icons';
import { ROUTES } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { Link } from '../../../Link/Link';

function ThankYouHelpSection() {
  const t = useTranslations('thank_you.help');

  return (
    <div className="flex items-center gap-2" data-testid="thank-you-help-section">
      <Help size="small" className="shrink-0" aria-hidden />
      <p className="paragraph flex items-center gap-2">
        <span>{t('prompt')}</span>
        <Link href={ROUTES.HELP_CENTRE.BASE_URL} target="_blank" rel="noopener noreferrer" data-testid="thank-you-help-centre-link" data-track-name="Help">
          {t('link')}
        </Link>
      </p>
    </div>
  );
}

export { ThankYouHelpSection };
